import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NetworkIndicator } from "@/components/NetworkIndicator";
import { LogOut, Monitor } from "lucide-react";

export function CounterHeader({ user, counters, counterId, onSelectCounter, onLogout, selectedCounter,
                                online, backendReachable, wsStatus }) {
  return (
    <header className="bg-white border-b border-slate-200 px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <img src={LOGO_URL} alt="MAMA" className="w-10 h-10" />
        <div>
          <div className="font-display font-bold text-slate-900">Interface Guichet</div>
          <div className="text-xs text-slate-500">
            {user?.full_name} · <span className="font-mono uppercase tracking-widest">{user?.role}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <NetworkIndicator online={online} backendReachable={backendReachable} wsStatus={wsStatus} />
        {selectedCounter?.allowed_categories?.length > 0 && (
          <div className="hidden md:flex items-center gap-1.5" data-testid="counter-allowed-cats">
            <span className="text-xs uppercase tracking-widest text-slate-400 mr-1">Catégories autorisées:</span>
            {selectedCounter.allowed_categories.map((c) => (
              <span key={c} className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-700 text-xs font-mono font-bold">
                {c}
              </span>
            ))}
          </div>
        )}

        <Select value={counterId} onValueChange={onSelectCounter}>
          <SelectTrigger className="w-56" data-testid="counter-select">
            <SelectValue placeholder="Sélectionnez un guichet" />
          </SelectTrigger>
          <SelectContent>
            {counters.map((c) => (
              <SelectItem key={c.id} value={c.id} data-testid={`counter-option-${c.counter_number}`}>
                {c.counter_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Link to="/display" target="_blank" rel="noopener noreferrer"
              className="text-xs text-slate-500 hover:text-[#DC2626] inline-flex items-center gap-1">
          <Monitor className="w-4 h-4" /> TV
        </Link>

        <Button variant="outline" size="sm" onClick={onLogout} data-testid="counter-logout">
          <LogOut className="w-4 h-4 mr-1" /> Déconnexion
        </Button>
      </div>
    </header>
  );
}
